import React from "react";

const Blank = () => {
    return (
        <>
            <p>
                Hello
            </p>
        </>
    )
}

export default Blank;